
import React, { useCallback, useEffect, useRef } from 'react';
// material-ui
import { Card, CardContent, Grid, Typography, Stack, Avatar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useAuth from 'hooks/useAuth';
// ==============================|| CHAT MESSAGE HISTORY ||============================== //

export type History = {
  from?: number | string
  to?: number | string
  time?: number | string
  text?: string
}

interface ChartHistoryProps {
  data: History[]
}

const ChartHistory = ({ data }: ChartHistoryProps) => {
  // scroll to bottom when new message is sent or received
  const { user } = useAuth();
  const theme = useTheme();
  const wrapper = useRef(document.createElement('div'))
  const el = wrapper.current

  const scrollToBottom = useCallback(() => {
    el.scrollIntoView(false)
  }, [el])

  useEffect(() => {
    scrollToBottom()
  }, [data && data.length, scrollToBottom])

  return (
    <Grid item xs={12}>
      <Grid container spacing={2} ref={wrapper}>
        {data &&
          data.length > 0 &&
          data.map((history, index) => (
            <React.Fragment key={index}>
              {history.from !== 'bot' ? (
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={10}>
                      <Card
                        sx={{
                          display: 'inline-block',
                          float: 'right',
                          bgcolor: theme.palette.primary[200]
                        }}
                      >
                        <CardContent sx={{ p: 2, pb: '16px !important', width: 'fit-content', ml: 'auto' }}>
                          <Grid container spacing={1}>
                            <Grid item xs={12}>
                              <div dangerouslySetInnerHTML={{ __html: history.text ?? "" }} />
                            </Grid>
                            <Grid item xs={12}>
                              <Typography align='right' variant='subtitle2' fontSize={'0.75rem'}>
                                {history.time}
                              </Typography>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item xs={2}>
                      <Stack direction="row" spacing={0.5} alignItems="center">
                        <Avatar
                          src={user?.avatar}
                          sx={{
                            ...theme.typography.mediumAvatar,
                            margin: '8px 8px 8px 8px !important',
                            cursor: 'pointer'
                          }}
                          color="inherit"
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={2}>
                      <Stack direction="row" spacing={0.5} alignItems="center">
                        <Avatar
                          src="/assistant.png"
                          sx={{
                            ...theme.typography.mediumAvatar,
                            margin: '8px 8px 8px 8px !important',
                            cursor: 'pointer'
                          }}
                          color="inherit"
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={10}>
                      <Card
                        sx={{
                          display: 'inline-block',
                          float: 'left',
                          background: theme.palette.warning.dark
                        }}
                      >
                        <CardContent sx={{ p: 2, pb: '16px !important' }}>
                          <Grid container spacing={1}>
                            <Grid item xs={12}>
                              <div dangerouslySetInnerHTML={{ __html: history.text ?? "" }} />
                            </Grid>
                            <Grid item xs={12}>
                              <Typography align='right' variant='subtitle2' fontSize={'0.75rem'}>
                                {history.time}
                              </Typography>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </React.Fragment>
          ))}
      </Grid>
    </Grid>
  )
}

export default ChartHistory
